import { render, staticRenderFns } from "./PositionEducations.vue?vue&type=template&id=7b38b68d"
import script from "./PositionEducations.vue?vue&type=script&lang=js"
export * from "./PositionEducations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports